<script setup lang="ts">
defineOptions({
  name: 'PaymentMethodsIndex',
})

import { computed, ref } from 'vue'
import { getTransferMethodsAction } from '@/api/functions/settings/transfer-method-actions'
import type { TransferMethodItem } from '@/api/typings/settings.typing'
import { useQueryApi } from '@/composables/useApi'
import { settingsTabs } from '@/constants/setting-tabs.ts'
import SettingsOverview from '../partials/SettingsOverview.vue'
import TransferMethodCard from './partials/TransferMethodCard.vue'
import TransferMethodModal from './partials/TransferMethodModal.vue'

const { data: transferMethodsData, refetch: refetchTransferMethods } = useQueryApi({
  queryKey: ['transfer-methods'],
  queryFn: () => getTransferMethodsAction(),
})

const transferMethods = computed(() => transferMethodsData.value?.data || [])

const isModalOpen = ref(false)
const selectedMethod = ref<TransferMethodItem | null>(null)

const openCreateModal = () => {
  selectedMethod.value = null
  isModalOpen.value = true
}

const openEditModal = (method: TransferMethodItem) => {
  selectedMethod.value = method
  isModalOpen.value = true
}

const handleUpdated = () => {
  refetchTransferMethods()
}
</script>

<template>
  <div class="w-full mb-12">
    <SettingsOverview :tabs="settingsTabs">
      <template #actions>
        <div class="flex items-center gap-2 pb-1">
          <Button :isAdmin="true" class="px-3! rounded-lg! h-8! py-0 text-[13px] font-medium" @click="openCreateModal">
            افزودن روش پرداخت جدید
          </Button>
        </div>
      </template>
    </SettingsOverview>
    <div class="mt-20 lg:mt-7 flex flex-col gap-4">
      <TransferMethodCard v-for="method in transferMethods" :key="method.id" :method="method" @updated="handleUpdated"
        @edit="openEditModal" />
    </div>

    <TransferMethodModal v-model="isModalOpen" :method="selectedMethod" @confirm="handleUpdated" />
  </div>
</template>
